<template>
  <div class="flex items-center justify-center w-full h-screen">
    <div data-loc="client/src/pages/NotFound.tsx:16" data-slot="card-content" class="px-[10px] tablet:px-[30px] pt-8 pb-8 text-center shadow-[0px_6px_20px_0px_#0000001A] rounded-[20px]">
      <div data-loc="client/src/pages/NotFound.tsx:17" class="flex justify-center mb-6">
        <div data-loc="client/src/pages/NotFound.tsx:18" class="relative">
          <div data-loc="client/src/pages/NotFound.tsx:19"
            class="absolute inset-0 bg-red-100 rounded-full animate-pulse">
          </div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-circle-alert relative h-16 w-16 text-red-500"
            data-loc="client/src/pages/NotFound.tsx:20">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="8" y2="12"></line>
            <line x1="12" x2="12.01" y1="16" y2="16"></line>
          </svg>
        </div>
      </div>
      <h1 data-loc="client/src/pages/NotFound.tsx:24" class="text-4xl font-bold text-slate-900 mb-2">404</h1>
      <h2 data-loc="client/src/pages/NotFound.tsx:26" class="text-xl font-semibold text-slate-700 mb-4">Page Not Found
      </h2>
      <p data-loc="client/src/pages/NotFound.tsx:30" class="text-slate-600 mb-8 leading-relaxed">Sorry, the page you are
        looking for doesn't exist.<br data-loc="client/src/pages/NotFound.tsx:32">It may have been moved or deleted.</p>
      <div data-loc="client/src/pages/NotFound.tsx:36" id="not-found-button-group"
        class="flex flex-col sm:flex-row gap-3 justify-center"><button data-loc="client/src/pages/NotFound.tsx:40" @click="back()"
          data-slot="button"
          class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-9 has-[&gt;svg]:px-3 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-house w-4 h-4 mr-2" data-loc="client/src/pages/NotFound.tsx:44">
            <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
            <path
              d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z">
            </path>
          </svg>Go Home</button></div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'NotFound',
  methods: {

    back() {
       window.location = process.env.VUE_APP_HOME_PAGE_URL
    }
  },
};
</script>

<style scoped>
body {
  font-family: 'Arial', sans-serif;
  background-color: #f4f4f4;
  color: #333;
  text-align: center;
  padding: 50px;
  margin: 0;
}
</style>